module.exports = __webpack_public_path__ + "static/media/83.c3a2b415.png";